export default defineNuxtPlugin(() => {
  // Ensure this only runs on the client and after the Nuxt app is ready
  if (import.meta.server) return

  onNuxtReady(() => {
    const { status, session } = useAuth()
    const router = useRouter()
    const localeRoute = useLocaleRoute()

    let redirected = false

    const tryRedirect = () => {
      if (redirected) return
      // Only redirect from root path to preserve deep links and other pages
      if (router.currentRoute.value.path !== '/') return
      if (status.value !== 'authenticated') return

      const org = (session.value?.user as any)?.app_metadata?.organization
      if (org !== 'singhealth') return

      const target = localeRoute({
        path: `/assistants/${org}/chats/start`,
        query: { selectAssistant: '1' }
      })
      const targetPath = target?.fullPath || `/assistants/${org}/chats/start?selectAssistant=1`

      if (router.currentRoute.value.fullPath === targetPath) return

      redirected = true
      router.replace(targetPath)
    }

    // Attempt immediately after app init
    queueMicrotask(tryRedirect)

    // Watch for status/org changes
    watch([status, () => (session.value?.user as any)?.app_metadata?.organization], () => {
      tryRedirect()
    }, { immediate: false })

    // Also trigger after each navigation if needed
    router.afterEach(() => {
      tryRedirect()
    })
  })
})
